import PubSub from "pubsub-js";
import { events } from "./Events";

export default class ProductRenderer {
  constructor() {
    this.DOM = {
      el: document.querySelector('[data-json="products"]')
    }
  }

  init() {
    if (!this.DOM.el) return;

    this.dataFetchToken = PubSub.subscribe(events.DATA_FETCHED, (msg, data) => {
      if (data.products.length) {
        this.render(data.products[0]);
        PubSub.unsubscribe(this.dataFetchToken);
      };
    });
  }

  render(productData) {
    const titleEl = this.DOM.el.querySelector('.products__tagline');
    const subtitleEl = this.DOM.el.querySelector('.products__text');
    const productImgBig = this.DOM.el.querySelector('.products__imagebox img');
    const productImgList = this.DOM.el.querySelector('.products__list');

    const productImages = [productData.img_2, productData.img_3, productData.img_4];

    if (productData.title) {
      titleEl.innerHTML = productData.title;
    }

    if (productData.subtitle) {
      subtitleEl.innerHTML = productData.subtitle;
    }

    if (productData.img_1) {
      productImgBig.setAttribute('src', `/special/groundbreakers/assets/images/${productData.img_1}`)
    }

    productImages.forEach(imageUrl => {
      if (imageUrl && imageUrl !== "") {
        productImgList.innerHTML += `<li class="products__item"><img src="/special/groundbreakers/assets/images/${imageUrl}" alt="" /></li>`
      }
    });
  }
}